// extracted by mini-css-extract-plugin
export default {"container":"UsernameBanner_container__HobzH","hand-icon":"UsernameBanner_hand-icon__4g4tD","text":"UsernameBanner_text__iR7tO"};